export default {
    ResizeSensor: require('css-element-queries/src/ResizeSensor'),
    init() {

        window.scrollBy(0,1);
        addEventListener("load", () => {
            if(window.innerWidth > 1200) {
                // setTimeout(() => {
                this.underline();
                // }, 201)
                // this.underline();
            } else {
                this.mobile_underline();
            }
        });

        //getting the height of the header holder.
        if(window.innerWidth <= 1200) {
            let header_holder = document.getElementsByClassName('header-holder')[0];
            if(header_holder) {
                let header_holder_height = header_holder.offsetHeight;
                let mobile_wiggle = header_holder.querySelector('.mobile-wiggle svg');
                mobile_wiggle.style.height = header_holder_height + "px";
            }
        }
        // //initialising the underline div.
        // if(window.innerWidth > 1200) {
        //     setTimeout(() => {
        //         this.underline();
        //     }, 201)
        //     // this.underline();
        // } else {
        //     this.mobile_underline();
        // }

        window.addEventListener('resize', () => {
            if(window.innerWidth > 1200) {
                // this.underline();
                this.underline();
            } else {
                let mobile_underline = document.querySelector('.underline.mobile');
                if(mobile_underline) {
                    mobile_underline.style.display = "block";
                    mobile_underline.nextElementSibling.style.display = "block";
                    let generated = document.querySelectorAll('.underline.generated');
                    if(generated) {
                        for(let i = 0; i < generated.length; i++) {
                            //removing the generated underline text and line.
                            generated[i].nextElementSibling.remove();
                            generated[i].remove();
                        }
                    }

                    this.mobile_underline();
                }
            }
        });        


    },

    mobile_underline() {
        let underline_span = document.querySelector('.underline.mobile');
        if(underline_span) {
            this.split_paragraph(underline_span);
            this.underline_lines(underline_span);
        }
        // this.getLine(underline_span);
        // let underline_width = underline_span.offsetWidth + "px";
        // underline_span.nextElementSibling.style.width = underline_width;
    },

    underline_lines(elem) {
        //getting each span in a given element.
        let spans = elem.getElementsByTagName("span");
        
        //object with all the y positions, each new y position will be a new object.
        let position_obj = {};

        //loopign through spans and getting the y position of each span
        for(let i = 0; i < spans.length; i++) {
            let span = spans[i];
            //y position
            let y = span.offsetTop;

            //if this is a new line that;s not set, create an array
            if(!position_obj[y]) {
                position_obj[y] = [span.textContent]
            } else {
                position_obj[y].push(span.textContent);
            }
            // console.log("Y: " + y + " index: " + i)
        }

        console.log("Lines: ", position_obj);

        //going through each line
        Object.keys(position_obj).forEach((key) => {
            //create line based on words of a certain y pos.
            let line = ""
            position_obj[key].forEach(word => {
                line += word + " ";
            });

            console.log("Line: " + line);
            this.add_line(line, elem)
        })

        elem.style.display = "none";
        elem.nextElementSibling.style.display = "none";
    },

    //adding line to the header
    add_line(line, elem) {
        let parent = elem.parentElement;
        let span = document.createElement("span");
        span.classList.add('underline', 'generated');
        span.innerHTML = line.trim();
        parent.appendChild(span);
        let underline = elem.nextElementSibling.cloneNode(true);
        // underline.style.width = span.offsetWidth + "px";
        underline.style.width = span.getBoundingClientRect().width + "px";
        // underline_span.nextElementSibling
        parent.appendChild(underline)

        this.ResizeSensor(span, () => {
            underline.style.width = span.getBoundingClientRect().width + "px";
        })
    },

    /* Splititng each word in a tag into a new span */
    split_paragraph(elem) {
        let text = elem.textContent;
        var words = text.split(" ");
        elem.innerHTML = "";
        
        words.forEach(word => {
            if(word !== "" && !/\s$/.test(word)) {
                elem.innerHTML += "<span>" + word + "</span> ";
            }
        });
    },

    getLine(elem, lineNum) {
        lineNum--;
        // var elem = document.getElementById(paragraphId);
        var spanChildren = elem.getElementsByTagName("span");
        var paragraphText = elem.innerHTML.replace(/(\r\n|\n|\r)/gm, "");
        var newParagraphText = "";
        var words = [];
        var max;
        if (spanChildren.length === 0) {
            words = paragraphText.split(" ");
            for (var i = 0; max = words.length, i < max; i++)
            newParagraphText += '<span>' + words[i] + "</span> ";
            elem.innerHTML = newParagraphText;
        }else{
            for(var i=0; max = spanChildren.length, i<max; i++){
                words[words.length] = spanChildren[i].innerHTML;
            }
        }
        var lineCounter = 0;
        var previousY = spanChildren[0].offsetTop;
        var returnText = "";
        var startReturning = false;
        var lines = [];
        for (var i = 0; max = words.length, i < max; i++) {
            if (spanChildren[i].offsetTop != previousY) lineCounter++;
            // if (lineCounter === lineNum) startReturning = true;
            // if (lineCounter !== lineNum && startReturning) return returnText.substring(0, returnText.length - 1);
            // if (startReturning) {
            //     returnText += words[i] + " ";
            //     if (i + 1 === words.length) return returnText.substring(0, returnText.length - 1);
            // }

            if(!lines[lineCounter]) {
                lines[lineCounter] = "";
            }

            if(words[i]) {
                lines[lineCounter] += words[i] + " ";
            }
            previousY = spanChildren[i].offsetTop;
        }

        if(lines.length > 0) {
            let underline = elem.nextElementSibling.cloneNode(true);
            let parent = elem.parentElement;
            elem.nextElementSibling.remove();
            elem.remove()

            lines.forEach(line => {
                parent.innerHTML += "<span class = 'underline'>" + line + "</span>"
            });
        }
        return lines;
    },
    underline() {
        let underline_spans = document.getElementsByClassName('underline');
        if(underline_spans.length > 0) {
            for(let i = 0; i < underline_spans.length; i++) {
                let underline_span = underline_spans[i];
                // console.log(this.getLine(underline_span, 1))
                // console.log(this.getLine(underline_span, 2))
                // let underline_width = underline_span.offsetWidth + "px";
                let underline_width = underline_span.getBoundingClientRect().width + "px";
                console.log("Underline width is: " + underline_width);
                underline_span.nextElementSibling.style.width = underline_width;
                this.ResizeSensor(underline_span, () => {
                    console.log("Resizing");
                    let underline_width = underline_span.getBoundingClientRect().width + "px";
                    console.log("Underline width is: " + underline_width);
                    underline_span.nextElementSibling.style.width = underline_width;
                })
            }
        }
    }
}